import * as R from 'ramda'
import React from 'react'

type PinPlaceholderProps = {
  length: number
}

const PinPlaceholder: React.FunctionComponent<PinPlaceholderProps> = ({ length }) => {
  if (length === 0) {
    return <span className="pin-digit-placeholder">{'\u00A0'}</span>
  } else {
    return (
      <>
        {R.repeat({}, length).map((d, i) => (
          <span className="pin-digit-placeholder" key={i}>
            {'●'}
          </span>
        ))}
      </>
    )
  }
}

export default PinPlaceholder



// WEBPACK FOOTER //
// ./src/components/mobile/PinPlaceholder.tsx